<template>
  <div class="fly-container">
    <div class="come-bar van-hairline--bottom" @click="show = true">
      <div class="title">数据来源</div>
      <div class="from">
        {{ dataFrom === "dj" ? "大疆/极飞APP" : "黑匣子"
        }}<van-icon name="arrow" class="arrow" size="15" />
      </div>
    </div>
    <div class="mid-bar" @click="showAllFlyData">
      <allFlyItem :flyData="allData"></allFlyItem>
    </div>
    <div class="list">
      <div
        class="item"
        v-for="item in activeFlyData.fly_data"
        :key="item.user_id"
        @click="openImagePreview(item)"
      >
        <flyItem :flyData="item"></flyItem>
      </div>
    </div>
    <p class="tip">
      {{ dataFrom === "dj" ? "用于计算飞行费用" : "飞行费用参考数据" }}
    </p>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      description="选择数据来源"
      close-on-click-action
      @select="selectDataFrom"
    />
    <van-overlay :show="overlayShow" @click="overlayShow = false">
      <NoFlyData></NoFlyData>
    </van-overlay>
  </div>
</template>
<script>
import flyItem from "@/components/fly_data_item/fly_data_item";
import allFlyItem from "@/components/all_fly_data_item/all_fly_data_item";
import NoFlyData from "@/components/no_fly_data/no_fly_data";
import { mapState } from "vuex";
import axios from "../../http";
import { ImagePreview, Overlay } from "vant";

export default {
  name: "fly_data_one",
  components: {
    flyItem,
    Overlay,
    NoFlyData,
    allFlyItem
    // [ImagePreview.Component.name]: ImagePreview.Component
  },
  props: {},
  data() {
    return {
      djData: "", //大疆数据
      hxzData: "", // 黑匣子数据
      dataFrom: window.sessionStorage.getItem("dataFrom") || "dj",
      show: false,
      actions: [
        { name: "大疆/极飞APP", id: "dj" },
        { name: "黑匣子", id: "hxz" }
      ],
      overlayShow: false
    };
  },
  computed: {
    ...mapState(["token"]),
    allData() {
      let obj = {};
      let img = require("../orderDetail/fly.png");
      obj["avatar"] = img;
      if (this.dataFrom === "dj") {
        obj["end_time"] = this.djData.end_time;
        obj["start_time"] = this.djData.start_time;
        obj["plane_count"] = this.djData.total_plane_count;
        obj["work_mu"] = this.djData.total_work_mu;
      } else {
        obj["end_time"] = this.hxzData.end_time;
        obj["start_time"] = this.hxzData.start_time;
        obj["plane_count"] = this.hxzData.total_plane_count;
        obj["work_mu"] = this.hxzData.total_work_mu;
      }
      return obj;
    },
    activeFlyData() {
      if (this.dataFrom === "dj") {
        return this.djData;
      } else {
        return this.hxzData;
      }
    },
    allDjFlyDataImage() {
      //所有的大疆飞线数据的图片数组
      let arr = [];
      this.djData.fly_data.forEach(item => {
        arr = arr.concat(item.images);
      });
      return arr;
    }
  },
  watch: {},
  mounted() {
    this.getMapData();
  },
  destroyed() {},
  methods: {
    getMapData() {
      axios
        .fetchPost("/api/order/fly_data", {
          token: this.token,
          order_sn: this.$route.query.order_sn
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            let re = data.data;
            this.djData = re["dj_data"];
            this.hxzData = re["hxz_data"];
          } else {
          }
        })
        .catch(e => {
          console.log("e :", e);
        });
    },
    selectDataFrom(value) {
      // 选择数据来源
      this.dataFrom = value.id;
      window.sessionStorage.setItem("dataFrom", value.id);
    },
    openImagePreview(item) {
      //轮播图预览 总飞行轨迹
      if (item.err_title !== "" && item.err_title !== "未开始作业") {
        // 未作业 或者未操作的情况 直接返回
        return;
      }
      if (this.dataFrom === "dj") {
        //大疆使用轮播图
        if (item.images.length === 0) {
          this.overlayShow = true;
        } else {
          ImagePreview({
            images: item.images,
            startPosition: 0
          });
        }
      } else {
        // 黑匣子 使用原来的map
        this.$router.push({
          path: "/maps",
          query: { order_sn: this.$route.query.order_sn }
        });
      }
    },
    showAllFlyData() {
      if (this.dataFrom === "dj") {
        if (this.allDjFlyDataImage.length === 0) {
          this.overlayShow = true;
          return;
        }
        ImagePreview({
          images: this.allDjFlyDataImage,
          startPosition: 0
        });
      } else {
        this.$router.push({
          path: "/maps",
          query: { order_sn: this.$route.query.order_sn }
        });
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.fly-container
  font-family: Microsoft YaHei;
  .come-bar
    display flex
    background #fff
    justify-content space-between
    align-items center
    height 50px
    padding 0 12px
    font-size 15px
    .title
      color #999
    .from
      color #282828
      .arrow
        font-weight bold
        color #BEBEBE
        margin-top: -3px;
        vertical-align: middle;
        font-size 15px
        margin-left 7px
  .list
    .item
      margin 10px 12px 0
.tip
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  padding 25px 0
</style>
